import { useEffect, useState } from "react";
import { Gift, X } from "lucide-react";
import { api } from "../lib/api";
import { getPendingReward, clearPendingReward, fmtExpiry } from "../lib/spin";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { toast } from "sonner";

export default function RewardBox({ items, email, reward, onChange }) {
  const [code, setCode] = useState(getPendingReward);
  const [busy, setBusy] = useState(false);

  const check = async (c = code, silent = false) => {
    if (!c.trim()) return;
    setBusy(true);
    try {
      const r = await api.post("/rewards/check", { code: c.trim(), email, items: items.map((i) => ({ item_id: i.item_id, price: i.price, quantity: i.quantity })) });
      onChange({ ...r.data, item_id: r.data.free_options?.[0]?.id || null });
      if (!silent) toast.success(`${r.data.label} applied`);
    } catch (e) {
      onChange(null);
      if (!silent) toast.error(e.response?.data?.detail || "Could not apply reward");
    } finally { setBusy(false); }
  };

  useEffect(() => { if (reward) check(reward.code, true); }, [items, email]); // eslint-disable-line react-hooks/exhaustive-deps

  const remove = () => { onChange(null); setCode(""); clearPendingReward(); };

  return (
    <section className="bg-white rounded-2xl border border-gray-100 p-5 space-y-3" data-testid="reward-box">
      <h2 className="font-display font-bold text-gray-900 flex items-center gap-2"><Gift size={16} className="text-[#CC1A00]" /> Spin &amp; Win reward</h2>
      {reward ? (
        <div className="rounded-xl bg-[#FBF6EE] border border-[#FF6600]/40 p-3 text-sm space-y-1" data-testid="reward-applied">
          <div className="flex justify-between gap-2"><b>{reward.label} · {reward.code}</b><button onClick={remove} data-testid="reward-remove"><X size={16} /></button></div>
          <div className="text-gray-600 text-xs">Expires {fmtExpiry(reward.expires_at)}</div>
          {reward.terms && <div className="text-xs font-semibold">{reward.terms}</div>}
          {reward.type === "free_item" && reward.free_options?.length > 0 && (
            <select className="w-full border rounded-lg p-2 text-sm bg-white" value={reward.item_id || ""} onChange={(e) => onChange({ ...reward, item_id: e.target.value })} data-testid="reward-free-item">
              {reward.free_options.map((o) => <option key={o.id} value={o.id}>Free: {o.name}</option>)}
            </select>
          )}
        </div>
      ) : (
        <>
          <div className="flex gap-2">
            <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="e.g. MLX-1A2B3C4D" data-testid="reward-code-input" />
            <Button onClick={() => check()} disabled={busy || !code.trim()} variant="outline" data-testid="reward-apply">Apply</Button>
          </div>
          <p className="text-xs text-gray-500">Use the email you verified for Spin &amp; Win. Free items need a meal purchase above 500 KSH.</p>
        </>
      )}
    </section>
  );
}
